export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_11.2ffee6e7.jpg";